<template>
  <div class="modal" v-bind:class="{ 'is-active': is_shown }">
    <div
      class="modal-background"
      @click="$props.is_closable ? close_modal() : null"
    ></div>
    <div
      class="modal-card"
      :style="
        is_wide
          ? 'width: calc(70% - 2em); height: calc(90% - 2em)'
          : size == 'fullscreen'
          ? 'width: calc(90% - 2em); height: calc(90% - 2em)'
          : ''
      "
    >
      <header class="modal-card-head">
        <p class="modal-card-title">{{ $props.title }}</p>
        <button
          class="delete"
          aria-label="close"
          v-if="is_closable"
          @click="close_modal"
        ></button>
      </header>
      <section class="modal-card-body" ref="modal_card_body">
        <slot></slot>
      </section>
      <footer class="modal-card-foot" v-if="show_footer">
        <p class="buttons">
          <slot name="footer"></slot>
          <button
            :class="'button ' + button.class"
            @click="button.click"
            v-for="(button, bidx) in $props.buttons"
            :key="bidx"
            :disabled="button.disabled"
          >
            <span class="icon"><i :class="button.icon"></i></span>
            <span>{{ button.text }}</span>
          </button>
          <button
            :class="'button ' + button.class"
            @click="button.click"
            v-for="(button, bidx) in alternate_buttons"
            :key="bidx"
            :disabled="button.disabled"
          >
            <span class="icon"><i :class="button.icon"></i></span>
            <span>{{ button.text }}</span>
          </button>
        </p>
      </footer>
    </div>
  </div>
</template>
<script>
export default {
  name: "GenericModal",
  // components: { Permissions },
  data() {
    return {
      is_shown: false,
      alternate_buttons: [],
    };
  },
  props: {
    title: {
      type: String,
      required: false,
      default: "default title",
    },
    buttons: {
      type: Array,
      required: false,
      default: () => {
        return [];
      },
    },
    is_wide: {
      type: Boolean,
      required: false,
      default: false,
    },
    size: {
      type: String,
      required: false,
      default: "medium",
    },
    is_closable: {
      type: Boolean,
      required: false,
      default: true,
    },
    show_footer: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  computed: {},
  methods: {
    set_initial_state() {
      let v = this;
      v.alternate_buttons = [];
    },
    close_modal() {
      let v = this;
      v.is_shown = false;
      v.set_initial_state();
      v.$emit("close-modal");

      /** Remove listener on ESC key */
      document.removeEventListener("keydown", v.esc_listener);
    },
    show_modal(options) {
      let v = this;
      v.set_initial_state();
      if (options && options.buttons) {
        v.alternate_buttons = options.buttons;
      }
      // v.init();
      v.is_shown = true;

      /** Set focus on first control */
      let element = v.$refs.modal_card_body;
      if (element) {
        let first_input = element.querySelector("input, select, textarea");
        // console.log("first_input", first_input);
        if (first_input) {
          setTimeout(() => {
            first_input.focus();
          }, 300);
        }
      }

      /** Set listener on ESC key */
      document.addEventListener("keydown", v.esc_listener);
    },
    esc_listener(event) {
      let v = this;
      if (event.key === "Escape") {
        v.close_modal();
      }
    },
    scroll_to_bottom() {
      let v = this;
      let element = v.$refs.modal_card_body;
      // console.log("scroll_to_bottom", element);
      if (element) {
        element.scrollTop = element.scrollHeight;
      }
    },
  },
  mounted() {},
};
</script>
<style scoped>
.modal {
  z-index: 101;
}
</style>
